// Global Instructions Rule Applied!

/**
 * Centralized currency code and symbol constants
 * These constants provide a single source of truth for currency-related values
 */

// ========================
// Currency Codes
// ========================
export const CURRENCY_CODE_USD = 'USD'
const CURRENCY_CODE_CHF = 'CHF'
const CURRENCY_CODE_EUR = 'EUR'
const CURRENCY_CODE_GBP = 'GBP'
const CURRENCY_CODE_JPY = 'JPY'
const CURRENCY_CODE_CAD = 'CAD'
const CURRENCY_CODE_AUD = 'AUD'
const CURRENCY_CODE_CNY = 'CNY'

// ========================
// Currency Symbols Mapping
// ========================
const CURRENCY_SYMBOLS: Record<string, string> = {
  [CURRENCY_CODE_USD]: '$',
  [CURRENCY_CODE_EUR]: '€',
  [CURRENCY_CODE_GBP]: '£',
  [CURRENCY_CODE_JPY]: '¥',
  [CURRENCY_CODE_CAD]: 'C$',
  [CURRENCY_CODE_AUD]: 'A$',
  [CURRENCY_CODE_CHF]: 'CHF',
  [CURRENCY_CODE_CNY]: '¥'
}

// ========================
// Default Currency
// ========================
const DEFAULT_CURRENCY_CODE = CURRENCY_CODE_USD

/**
 * Get currency symbol by currency code
 * @param currencyCode - Currency code (e.g., 'USD', 'EUR')
 * @returns Currency symbol or the currency code itself if not found
 */
export function getCurrencySymbol(currencyCode: string | null | undefined): string {
  if (!currencyCode) return CURRENCY_SYMBOLS[DEFAULT_CURRENCY_CODE] || DEFAULT_CURRENCY_CODE
  return (
    CURRENCY_SYMBOLS[currencyCode] || currencyCode || CURRENCY_SYMBOLS[DEFAULT_CURRENCY_CODE] || DEFAULT_CURRENCY_CODE
  )
}
